import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import "./App.css";
import Header from './components/header/Header';
import ClientLogos from './components/home/ClientLogos';
import About from './components/about/About';
import Skills from './components/skills/Skills';
import Services from './components/services/Services';
import Qualification from './components/qualification/Qualification';
import Work from './components/work/Work';
import Contact from './components/contact/Contact';
import Certificates from './components/certificates/Certificates';
import Footer from './components/footer/Footer';
import ScrollUp from './components/scrollup/ScrollUp';
import ProjectDetail from './components/project/ProjectDetail';
import SmoothScroll from './components/ui/SmoothScroll';
import SectionRouter from './components/ui/SectionRouter';
import LazySection from './components/ui/LazySection';

const MainContainer = () => (
    <>
        <SectionRouter />
        <Header />
        <SmoothScroll ease={0.08}>
            <main className='main'>
                {/* 1. About Me (no headers) */}
                <About showHeader={false} />

                {/* 2. Trusted and Collab */}
                {/* <LazySection rootMargin="200px">
                    <ClientLogos />
                </LazySection> */}

                {/* 3. Portfolio */}
                <LazySection rootMargin="300px">
                    <Work />
                </LazySection>

                {/* 4. Qualification */}
                <LazySection rootMargin="300px">
                    <Qualification />
                </LazySection>

                {/* 5. Services */}
                <LazySection rootMargin="300px">
                    <Services />
                </LazySection>

                {/* 6. Skills */}
                <LazySection rootMargin="300px">
                    <Skills />
                </LazySection>

                {/* 7. Certificates */}
                <LazySection rootMargin="300px">
                    <Certificates />
                </LazySection>

                {/* 8. Contact */}
                <LazySection rootMargin="200px">
                    <Contact />
                </LazySection>
            </main>
            <Footer />
        </SmoothScroll>
        <ScrollUp />
    </>
);

const App = () => {
    return (
        <BrowserRouter>
            <Routes>
                <Route path="/" element={<MainContainer />} />
                <Route path="/project/:id" element={<ProjectDetail />} />
            </Routes>
        </BrowserRouter>
    );
};

export default App;